import { useEffect, useState } from "react";
import TransactionServices from "../Transaction/TransactionServices";
import SuggestedPaymentUploadBox from "components/Payment/SuggestedPaymentUpload";
import AdvancedSearchBox from "components/Payment/AdvancedSearch";
import PaymentServices from "components/Payment/PaymentServices";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";
import ExportOption from "components/Common/exportOption";
import Pagination from "components/Common/newPagination";
import DeleteDialogueBoxV2 from "components/Common/DeleteDialogueV2";

export default function SuggestedPayment(subEntity: any) {

    let [expand, SetExpand] = useState(-10);
    let [Periods, setPeriods] = useState("");
    let [TotalSum, setTotalSum] = useState(0);
    let [searchFor, setSearchFor] = useState("");
    let [description, setDescription] = useState("");
    let [deleteType, setDeleteType] = useState<any>([]);
    let [deleteMessage, setDeleteMessage] = useState('');
    let [TotalPayments, setTotalPayments] = useState(0);
    let [tempTotalPayments, setTempTotalPayments] = useState(0);
    let [exportOption, setExportOption] = useState(false);
    let [deleteStatus, setDeleteStatus] = useState(false);
    let [editSuggested, setEditSuggested] = useState(-10);
    let [TotalRoyalties, setTotalRoyalties] = useState(0);
    let [TotalopeningBal, setTotalopeningBal] = useState(0);
    let [searchPayload, SetSearchPayload] = useState<any>([]);
    let [paymentDetail, setPaymentDetail] = useState<any>([]);
    let [PeriodListing, setPeriodListing] = useState<any>([]);
    let [TotalPaymentMake, setTotalPaymentMake] = useState(0);
    let [minPayEdit, setMinPayEdit] = useState(0);
    let [crossedEdit, setCrossedEdit] = useState(false);
    let [contractPayment, setContractPayment] = useState<any>([]);
    let [exportOptionType, setExportOptionType] = useState("");
    let [updatedAPayment, seupdatedAPayment] = useState<any>([]);
    let [TotalPeriodBalance, setTotalPeriodBalance] = useState(0);
    let [cummulativeTotalBal, setCummulativeTotalBal] = useState(0);
    let [PayOpeningBalance, setPayOpeningBalance] = useState(false);
    let [deleteSelectData, setDeleteSelectData] = useState<any>([]);
    let [paymentDetailTemp, setPaymentDetailTemp] = useState<any>([]);
    let [advancedSearchStatus, setAdvancedSearchStatus] = useState(false);
    let [subpagination, setSubpagination] = useState({ pageNumber: 1, pageSize: 10 });
    let [suggestedPaymentUploadStatus, setSuggestedPaymentUploadStatus] = useState(false);

    useEffect(() => {

        const modal = document.getElementById("myModal") as HTMLElement;
        console.log(modal)

        if (modal) {
            PaymentServices.periodCountList().then((value: any) => {
                setPeriodListing(value);
                for (var $i = 0; $i < value.length; $i++) {
                    if (value[$i].periodCurrent === 1) {
                        setPeriods(value[$i].periodDesc);
                    }
                }
            })
        }

    }, [subEntity]);

    const closeModal = (e: any) => {
        const modal = document.getElementById("myModal") as HTMLElement;
        modal?.classList.remove("displayItem");
        modal?.classList.add("displayNoneItem");
        document.body.classList.remove("HiddenoverflowX");
    }

    var payLoad = { paymentType: "Contact", showZeroBal: true, crossed: true, uncrossed: true, royalty: true, biannual: 3, quarterly: 2, monthly: 1 }

    const SearchListing = () => {
        TotalPaymentMake = 0
        setTotalPaymentMake(TotalPaymentMake)

        TotalSum = 0
        setTotalSum(TotalSum)

        cummulativeTotalBal = 0
        setCummulativeTotalBal(cummulativeTotalBal)

        TotalPeriodBalance = 0
        setTotalPeriodBalance(TotalPeriodBalance)

        TotalopeningBal = 0
        setTotalopeningBal(TotalopeningBal)

        TotalPayments = 0
        setTotalPayments(TotalPayments)

        tempTotalPayments = 0
        setTempTotalPayments(tempTotalPayments)

        TotalRoyalties = 0
        setTotalRoyalties(TotalRoyalties)

        console.log(searchPayload)
        console.log(Object.keys(searchPayload).length)
        if (Object.keys(searchPayload).length > 0) {
            payLoad = searchPayload
        }
        TransactionServices.getPaymentDetails(Periods, payLoad).then((res: any) => {
            for (var $i = 0; $i < res.length; $i++) {
                TotalPaymentMake = TotalPaymentMake + res[$i].totalSum
                setTotalPaymentMake(TotalPaymentMake)

                TotalSum = TotalSum + res[$i].totalSum
                setTotalSum(TotalSum)

                cummulativeTotalBal = cummulativeTotalBal + res[$i].cummulativeTotalBal
                setCummulativeTotalBal(cummulativeTotalBal)

                for (var $y = 0; $y < res[$i]?.contracts?.length; $y++) {
                    TotalopeningBal = TotalopeningBal + res[$i]?.contracts[$y].openingBal
                    setTotalopeningBal(TotalopeningBal)

                    TotalPayments = TotalPayments + res[$i]?.contracts[$y].paymentsAll
                    setTotalPayments(TotalPayments)

                    tempTotalPayments = tempTotalPayments + res[$i]?.contracts[$y].paymentsAll
                    setTempTotalPayments(tempTotalPayments)

                    TotalPeriodBalance = TotalPeriodBalance + res[$i]?.contracts[$y].periodBal
                    setTotalPeriodBalance(TotalPeriodBalance)

                    TotalRoyalties = TotalRoyalties + res[$i]?.contracts[$y].royalties
                    setTotalRoyalties(TotalRoyalties);
                }
            }
            paymentDetailTemp = res;
            setPaymentDetailTemp(paymentDetailTemp)

            paymentDetail = paymentDetailTemp?.slice(0, 10)
            setPaymentDetail(paymentDetail)


        })
    }

    const createSnapshot = () => {
        PaymentServices.updatedAPayment(payLoad).then((res: any) => {
            console.log(res)
            updatedAPayment = res
            seupdatedAPayment(res)
        })
    }

    const downloadFile = (e: any) => {
        console.log(e)
        var url = 'Api/metaData/genericV1/getDataManagementTemplate/tmpSugPay'
        window.open(url);
    }

    const suggestedPaymentUpload = () => { setSuggestedPaymentUploadStatus(true) }

    const SuggestedPaymentUploadClose = () => {
        suggestedPaymentUploadStatus = false
        setSuggestedPaymentUploadStatus(false)
    }

    const advancedSearch = () => { setAdvancedSearchStatus(true) }

    const AdvancedSearchClose = (Event: any) => {
        if (Event) {
            console.log(Event)
            searchPayload = Event
            SetSearchPayload(searchPayload);
            SearchListing();
        }
        advancedSearchStatus = false
        setAdvancedSearchStatus(false)
    }

    const deleteDialogue = (objectType: any, selectData: any) => {

        description = ""
        setDescription(description);

        deleteType = objectType
        setDeleteType(deleteType)

        deleteSelectData = selectData
        setDeleteSelectData(deleteSelectData)
        setDeleteStatus(true)

        if (deleteType == "PayPerKontact") {
            console.log("PAY BY KONTACT")
            deleteMessage = "pay all contacts";
            setDeleteMessage(deleteMessage)
        }

        if (deleteType == "Create Opening Balance") {
            console.log("Create")
            deleteMessage = "create the opening balance";
            setDeleteMessage(deleteMessage)
        }

        if (deleteType == "PayAll") {
            console.log("PAY ALL")
            deleteMessage = "pay all contacts";
            setDeleteMessage(deleteMessage)
        }

        if (deleteType == "PayPerContract") {
            console.log("PayPerContract")
            deleteMessage = "pay this contract";
            setDeleteMessage(deleteMessage)

            description = "<span class ='ws-12 mtxl mrl'> <span class ='ws-2 text-bold mtl'> Description:</span> <input value='Payment for period'/> </span> "
            setDescription(description);
        }

        if (deleteType == "savePaymentKontactPaymentInfo") {
            console.log("savePaymentKontactPaymentInfo")
            deleteMessage = "";
            setDeleteMessage(deleteMessage)

            description = "Please note that the values will be updated once you reset the grid.To view updated grid you will need to reset which is a time consuming process.If you have other changes to make, please complete with them and then do a Save & Reset "
            setDescription(description);
        }
    }

    const DeleteDialogueBoxClose = (e: any) => {

        //e==1 YES 
        if (e == 1) {
            //uploadDelete();        
            if (deleteType == "PayPerKontact") {
                console.log("PAY BY KONTACT")
                var payload = { paymentType: "Contact", hold: false, payOpeningBalance: PayOpeningBalance }

                PaymentServices.savePayment(Periods, payload, deleteSelectData)
                console.log(deleteSelectData)
                console.log(payload)
            }

            if (deleteType == "Create Opening Balance") {
                console.log("Create")
                var OpeningBalance_payload = { IncludeALLContracts: 1, Period: Periods }
                PaymentServices.ReCalcOpeningBalance(OpeningBalance_payload)
            }

            if (deleteType == "PayAll") {
                console.log("PAY ALL")
                console.log(paymentDetail)
                var payload_param = { paymentType: "Contact", hold: false, payOpeningBalance: PayOpeningBalance }
                var payload_contract_all = { contacts: paymentDetailTemp }
                PaymentServices.savePayment(Periods, payload_param, payload_contract_all)
            }

            if (deleteType == "PayPerContract") {
                console.log(deleteSelectData)

                deleteSelectData.detailDescription = "Payment for period"

                console.log(contractPayment)
                var pay_ment_val = contractPayment?.filter((event: any) => event.contract = deleteSelectData?.contractRefNum)
                console.log(pay_ment_val[0])
                console.log(pay_ment_val[0].payment)
                console.log(pay_ment_val[0].payment)
                if (pay_ment_val[0]) {
                    deleteSelectData.suggestedPayment = Number(pay_ment_val[0].payment) ?? 0
                }

                var payload_PayPerContract = {
                    contactCrossed: false, kontactCode: deleteSelectData?.kontactCode,
                    kontactDisplay: deleteSelectData?.kontactDisplay, kontactname: deleteSelectData?.kontactname,
                    minPay: 0, contracts: deleteSelectData
                }

                var payload = { paymentType: "Contact", hold: false, payOpeningBalance: PayOpeningBalance }
                var select_payload = [{ contacts: payload_PayPerContract }]
                console.log(deleteSelectData)
                console.log(payload_PayPerContract)

                PaymentServices.savePayment(Periods, payload, select_payload).then((respond: any) => {
                    setContractPayment((prev: any) => prev.filter((x: any) => x.contract !== deleteSelectData?.contractRefNum));
                })
            }

        }
        //e==2 NO 
        deleteStatus = false
        setDeleteStatus(false)
    }
    const DeleteDialogueBoxCloseV2 = (e: any) => {
        console.log(deleteSelectData)
        //e==1 SAVE 

        if (e > 0) {
            var payload = { kontactCode: deleteSelectData?.kontactCode, minPay: minPayEdit, contactCrossed: crossedEdit, paymentType: "Contact", period: Periods }
            PaymentServices.savePaymentKontactInfo(payload)
        }

        //e==1 SAVE AND RESET
        if (e == 2) { createSnapshot(); }

        deleteStatus = false
        setDeleteStatus(false)
    }

    const exportOptionUX = (e: any) => {
        exportOptionType = e;
        setExportOptionType(exportOptionType)

        exportOption = true;
        setExportOption(exportOption)
    }

    const onChangeExportOption = (e: any) => {
        console.log(e)
        console.log(exportOptionType)
        if (e.optSts === 1) {

            var Export_payload = {
                fileFormat: e.fileFormat,
                fileName: e.fileName,
                numRows: e.numRows,
                period: Periods,
                paymentType: "BulkPayment"
            }
            console.log(Export_payload)

            if (exportOptionType == "BulkPayment") {
                Export_payload.paymentType = "BulkPayment"
                payLoad.paymentType = "BulkPayment"
                PaymentServices.suggestedPaymentExport({ ...Export_payload, ...payLoad })
            } else if (exportOptionType == "Export") {
                Export_payload.paymentType = "Contact"
                payLoad.paymentType = "BulkPayment"
                PaymentServices.suggestedPaymentExport({ ...Export_payload, ...payLoad })
            }
        }

        exportOption = false;
        setExportOption(exportOption)
    }

    var pagination = { pageNumber: 1, pageSize: 10 }
    const SuggestedPaymentPagination = (e: any) => {
        pagination.pageNumber = e.pageNumber
        pagination.pageSize = e.pageSize

        paymentDetail = paymentDetailTemp?.slice((pagination.pageNumber - 1) * pagination.pageSize, (pagination.pageSize * pagination.pageNumber))
        setPaymentDetail(paymentDetail);
    }

    const SuggestedPaymentSubPagination = (e: any) => {
        subpagination.pageNumber = e.pageNumber
        subpagination.pageSize = e.pageSize

        setSubpagination({ ...subpagination })
    }

    const SelectStatus = (kontactDetail: any, statusNumber: any) => {
        console.log(kontactDetail)
        console.log(statusNumber)
        var url = Periods + '/' + statusNumber + '/' + kontactDetail.contractRefNum
        PaymentServices.saveStatusFlag(url)
    }

    const suggestedPaymentValue = (value: any, contract: any) => {

        console.log(value);
        console.log(contract);

        const newValue = value;
        setContractPayment((prev: any) => {
            const filtered = prev.filter((x: any) => x.contract !== contract?.contractRefNum);
            return [...filtered, { contract: contract?.contractRefNum, payment: value }
            ];
        });

        console.log(newValue);

        for (var i = 0; i < contractPayment.length; i++) {

            console.log(TotalPayments)
            console.log(contractPayment[i])
            console.log(tempTotalPayments)
            TotalPayments = Number(tempTotalPayments) + Number(contractPayment[i]?.payment)
            console.log(TotalPayments)

            setTotalPayments((prev) => TotalPayments);
        }

    }

    const getSuggestedPayment = (e: any) => {
        //console.log(e)
        // values?.suggestedPayment?.toFixed(2)
        var suggested_Payment = e?.suggestedPayment?.toFixed(2)

        //console.log(contractPayment)
        var contract_find = contractPayment?.filter((event: any) => event.contract == e?.contractRefNum)
        //console.log(contract_find)
        if (contract_find[0]?.contract) {
            suggested_Payment = contract_find[0]?.payment
        }
        return suggested_Payment;
    }

    return (<>

        {(subEntity) && <div id="myModal" className="modal pLarge ws-12 ">

            <a onClick={() => closeModal(true)} className="btn-xxs modalClose borderNone bgTransparent" style={{ position: "inherit" }} href="../../">
                <i className="icon-close3 danger"></i>
            </a>

            <div className="allowHscroll allowVscroll full-height-vh95 ws-12 box landing" style={{ minHeight: "80%" }}>

                <div className="box-header-main">
                    <h2 className="ws-3">Payment Schedule</h2>
                    <div className="ws-8 pull-right mrxl prl">
                        <button className="btn icon-btn edit pull-right width100 height35 " onClick={() => suggestedPaymentUpload()}>Upload</button>
                        <button className="icon-btn primary pull-right width100 height35" title="Download Templates" onClick={downloadFile}>Download</button>
                        <button className="icon-btn edit pull-right width200 height35" title="Create Opening Balance" onClick={() => deleteDialogue("Create Opening Balance", {})}>Create Opening Balance</button>
                        <button className="btn icon-btn info pull-right width150 height35" title="Create Snapshot" onClick={createSnapshot}>Create Snapshot</button>
                    </div>
                </div>

                <div className="box-content box">
                    <div className="pull-right mll ws-12 mt">
                        <label className="switch ws-2 mr pull-right">
                            <input type="checkbox" className="checkbox-inline" checked={PayOpeningBalance} onClick={() => setPayOpeningBalance(!PayOpeningBalance)}></input>
                            {PayOpeningBalance && <span className="slider round text-left white pm pts">Yes</span>}
                            {!PayOpeningBalance && <span className="slider round text-right white pm pts sliderOff">No</span>}
                        </label>
                        <div className="pull-right mr">Pay Opening Balance</div>
                    </div>

                    <div className="ws-12 pbl">

                        <div className="ws-3">
                            <label className="control-label text-bold">Period:</label>
                            <div className="label-entries">
                                <select className="form-control " id="period" value={Periods} onChange={(e) => setPeriods(e.target.value)}>

                                    {
                                        PeriodListing?.map((value: any) => {
                                            return (
                                                <option className={value.periodOpen === 2 ? "btn" : "icon-btn edit opacityDisabled"} value={value.periodDesc}>
                                                    {CommonUtilities.dateNameFilter(value.periodFrom) + " - " + CommonUtilities.dateNameFilter(value.periodTo)}
                                                </option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>

                        <div className="ws-6 mtl mll">
                            <button className="btn white bg-level7 p8 m0 ws-2 pull-right buttonLoad mt height35" onClick={SearchListing}>Search</button>
                            <input type="text" placeholder="Type to search" value={searchFor} onChange={(e: any) => setSearchFor(e.target.value)} className="p7 ws-10 heightReset border-green pull-right mt height35" />
                        </div>

                        <div className="ws-2 mtl pull-right  ">
                            <button className="btn-purple pm m0 ws-12 " onClick={() => advancedSearch()}> Advanced Search
                                <i className=" icon-params1 pull-right"> </i>
                            </button>
                        </div>

                    </div>

                    <div className="alert alert-warning ws-12 mt pm hide" ng-show="resetWarning">  Generate new workspace before you can start working   </div>
                </div>

                <div className="ws-12 pm">

                    <div className="ws-12 well cursor-hand ps mt mb borderRounded box" style={{ border: "solid 1px #646aa7" }}>
                        <div className="w-12 pm">
                            <span className="text-bold ws-12 pm text-center">Opening Balance</span>
                            <span className="pm ws-12 text-right ">
                                {TotalopeningBal < 0 ? `(${Math.abs(TotalopeningBal).toFixed(2)})` : TotalopeningBal?.toFixed(2)}
                                <input type="radio" className="pull-right ws-2" ng-click="changeOpeningTotal()" name="totalBalBT" />
                            </span>
                        </div>
                        <hr className="w-1 divider" />
                        <div className="w-12 pm">
                            <span className="text-bold ws-12 pm text-center">Payments</span>
                            <span className="pm ws-12 text-center "> {TotalPayments < 0 ? `(${Math.abs(TotalPayments).toFixed(2)})` : TotalPayments?.toFixed(2)}</span>
                        </div>
                        <hr className="w-1 divider" />
                        <div className="w-12 pm">
                            <span className="text-bold ws-12 pm text-center">Period Balance</span>
                            <span className="pm ws-12 text-center "> {TotalPeriodBalance < 0 ? `(${Math.abs(TotalPeriodBalance).toFixed(2)})` : TotalPeriodBalance?.toFixed(2)}</span>
                        </div>
                        <hr className="w-1 divider" />
                        <div className="w-12 pm">
                            <span className="text-bold ws-12 pm text-center">Royalties</span>
                            <span className="pm ws-12 text-center ">{TotalRoyalties < 0 ? `(${Math.abs(TotalRoyalties).toFixed(2)})` : TotalRoyalties?.toFixed(2)}</span>
                        </div>
                        <hr className="w-1 divider" />
                        <div className="w-12 pm">
                            <span className="text-bold ws-12 pm text-center">Closing Balance</span>
                            <span className="pm ws-12 text-right ">
                                {cummulativeTotalBal < 0 ? `(${Math.abs(cummulativeTotalBal).toFixed(2)})` : cummulativeTotalBal?.toFixed(2)}
                                <input type="radio" className="pull-right ws-2" name="totalBalBT" />
                            </span>
                        </div>
                        <hr className="w-1 divider" />
                        <div className="w-30 pm">
                            <div className="ws-12">
                                <div className="mt">
                                    <label className="ws-12 text-bold m0 text-left mt mr mb">Payment to Make</label>
                                    <input type="text" readOnly data-ng-model="topTotal" className="text-right text-bold ws-4 mt height35" value={TotalPaymentMake.toFixed(2)} />
                                </div>
                                <div className="ws-6 mt ml">
                                    <button className="icon-btn info text-right mb height35" ng-hide="saveTopAllLoading" onClick={() => deleteDialogue("PayAll", {})}>Pay All</button>
                                    <button className="btn-search text-right mb  hide" ng-show="saveTopAllLoading">
                                        <i className="icon-spinner3"></i>
                                    </button>

                                    <div className="verticalMediumWide hover-box pull-left mb">

                                        <div className="hover-block textboxDropdownList box rightReset  overflowVisible width450 mtl" >
                                            <a className="hover-box icon-btn edit btn-sm forceSingleLine ws-5" onClick={() => exportOptionUX("BulkPayment")}>Bulk Payment Export</a>
                                            <a className="hover-box icon-btn edit btn-sm forceSingleLine ws-3" onClick={() => exportOptionUX("Export")}>Export</a>
                                            <a className="hover-box icon-btn edit btn-sm forceSingleLine ws-3" target="_blank" href={"/CrystalReport/ContractListing.aspx?template=Reports/ContractListingRpt.rpt&periodNum=" + Periods}>RPT</a>

                                        </div>

                                        <a className="icon-btn edit">Export</a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div className="ws-12 pm">
                    <table className="landing" style={{ boxShadow: "none" }}>
                        <thead>
                            <tr>
                                <th className="ws-2 purple text-bold" style={{ background: "#F0F2F6 !important", border: "none" }}>Contact</th>
                                <th className="ws-2 purple text-bold" style={{ background: "#F0F2F6 !important", border: "none" }}>Crossed Y/N</th>
                                <th className="ws-2 purple text-bold" style={{ background: "#F0F2F6 !important", border: "none" }}>Min Payment</th>
                                <th className="ws-2 purple text-bold" style={{ background: "#F0F2F6 !important", border: "none" }}> Closing Balance</th>
                                <th className="ws-2 purple text-bold" style={{ background: "#F0F2F6 !important", border: "none" }}>Payment to Make</th>
                            </tr>
                        </thead>
                    </table>

                    {paymentDetail?.map((values: any, index: any) => {
                        return (
                            <div className="bg-white ws-12 mt mb">

                                <div className="ws-12 box pm overflowVisible">
                                    <div className="ws-12 pm ">
                                        <div className="ws-2 pull-left pm">
                                            <h3 className="ws12 purple text-bold">{values?.kontactname} - {values?.kontactCode} [{values?.contracts?.length}]</h3>
                                        </div>

                                        <div className="ws-2  pull-left">
                                            {editSuggested == index && <>
                                                <label className="mr pull-left ">
                                                    Crossed
                                                    <input type="checkbox"  value="true" checked={crossedEdit} onClick={() => setCrossedEdit(!crossedEdit)} />
                                                </label>
                                            </>}

                                            {editSuggested != index && <>
                                                {values?.contactCrossed && <button className="btn-sm icon-btn edit pull-left mr mll "> Y  </button>}
                                                {!values?.contactCrossed && <button className="pull-left mr btn-sm icon-btn delete mll "> N </button>}
                                            </>}
                                        </div>

                                        <div className="ws-2 pull-left">
                                            {editSuggested != index && <label className=" text-center" title="0">  {values?.minPay?.toFixed(2)} </label>}
                                            {editSuggested == index && <input className="text-right ws-4" type="text" value={minPayEdit?.toFixed(2)} onChange={(e: any) => setMinPayEdit(e.target.value)}></input>}
                                        </div>

                                        <div className="ws-2 pull-left">
                                            <label className="text-right ">  {values?.cummulativeTotalBal < 0 ? `(${Math.abs(values?.cummulativeTotalBal).toFixed(2)})` : values?.cummulativeTotalBal?.toFixed(2)}</label>
                                        </div>

                                        <div className="ws-4 pull-left">
                                            <div className="ws-12 m0 ml pull-right">
                                                <div className="ws-4">
                                                    <input type="text" className="text-right text-bold ws-12 " value={values.minPay} readOnly />
                                                </div>

                                                <div className="ws-3">
                                                    <button className="icon-btn info pull-right" onClick={() => deleteDialogue("PayPerKontact", values)}> Pay all  </button>
                                                </div>

                                                <div className="ws-3">
                                                    {editSuggested == index && <a className="btn icon-btn delete pull-right btn-sm" title="Cancel" onClick={() => setEditSuggested(-10)}>
                                                        <i className="icon-close"></i>
                                                    </a>}

                                                    {editSuggested != index && <a className="btn icon-btn edit btn-sm pull-right" title="Edit" onClick={() => setEditSuggested(index)}>
                                                        <i className="icon-edit-pencil"></i>
                                                    </a>}

                                                    {editSuggested == index && <a className="btn icon-btn edit pull-right btn-sm" title="Save" onClick={() => deleteDialogue("savePaymentKontactPaymentInfo", values)}>
                                                        <i className="icon-save"></i>
                                                    </a>}
                                                </div>

                                                <div className="ws-2">
                                                    {expand == index && <button className="icon-btn info btn-sm pull-right pm" onClick={() => SetExpand(-10)}>
                                                        <i className="text-s m0 icon-arrow"></i>
                                                    </button>}

                                                    {expand != index && <button className="icon-btn info btn-sm pull-right pm" onClick={() => SetExpand(index)}>
                                                        <i className="text-s m0 icon-arrow-point-to-right-2 "></i>
                                                    </button>}

                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div className="ws-12 mb">
                                        {expand == index && <>

                                            <div className="ws-12 mt">
                                                <span className="w-20 ">Contract</span>
                                                <span className="text-right text-bold ws-1">Opening Balance</span>
                                                <span className="text-right text-bold ws-1">Payments</span>
                                                <span className="text-right text-bold ws-1">Period Bal</span>
                                                <span className="text-right text-bold ws-1">Royalties</span>
                                                <span className="text-right text-bold ws-1">Closing Balance</span>
                                                <span className="text-center text-bold ws-3">Payment to Make</span>
                                                <span className="text-center text-bold ws-1">Status</span>
                                            </div>

                                            {values?.contracts?.slice((subpagination.pageNumber - 1) * subpagination.pageSize, (subpagination.pageSize * subpagination.pageNumber))
                                                .map((values: any, index: any) => {

                                                    return (
                                                        <div className="ws-12  mt overflowVisible" style={{ boxShadow: "none !important" }}>
                                                            <div className="alert alert-danger hide"> Enter a payment for at least one contract </div>
                                                            <div className="alert alert-success hide"> Payment done </div>
                                                            <div className="alert alert-info hide"> No contracts found </div>

                                                            <div className="ws-12 height55 overflowVisible">

                                                                <div className="notableBordered w-20 pr pt height50 border-bottom">
                                                                    <a className="ws-12 mb text-bold " title="ROY Contract">{values?.contractRefNum} </a>
                                                                    <span title={values?.contracttitle} >{values?.contracttitle} </span>
                                                                </div>

                                                                <div className="text-right notableBordered border-right border-bottom ws-1 pr pt height50  ">
                                                                    <span title="0" > {values?.openingBal?.toFixed(2)} </span>
                                                                    <input type="radio" className="pull-right ml " name="payBalT" ng-model="totalPayBal" />
                                                                </div>

                                                                <div className="text-right notableBordered border-right border-bottom  ws-1 pr pt height50  ">
                                                                    <a title="Payments Indicator">{values?.paymentsAll?.toFixed(2)}  </a>
                                                                </div>

                                                                <div className="text-right notableBordered border-right border-bottom  ws-1 pr pt height50  ">
                                                                    <span title="0" >{values?.periodBal?.toFixed(2)}</span>
                                                                </div>

                                                                <div className="text-right notableBordered border-right border-bottom  ws-1 pr pt height50  ">
                                                                    <span title="0" >{values?.royalties?.toFixed(2)} </span>
                                                                </div>

                                                                <div className="text-right notableBordered border-right border-bottom  ws-1 pr pt height50  ">
                                                                    <span title="0">{values?.closingBal?.toFixed(2)} </span>
                                                                    <input type="radio" className="pull-right ml " name="payBalT" ng-model="totalPayBal" />
                                                                </div>

                                                                <div className="text-right notableBordered border-right border-bottom  ws-3 pr pt height50  ">

                                                                    <div className="text-center" style={{ marginLeft: "22%" }}>
                                                                        <input type="text" className="text-right ws-7 ----suggestedPayment"
                                                                            onChange={(e: any) => suggestedPaymentValue(e?.target?.value, values)}
                                                                            value={getSuggestedPayment(values)} />

                                                                        <div className="ws-2 ml">
                                                                            <a className="icon-btn info" onClick={() => deleteDialogue("PayPerContract", values)}> Pay</a>
                                                                            <a className="icon-btn info hide"> <i className="icon-spinner3"></i>  </a>
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div className="notableBordered border-bottom w-13 pr pt height50 ">

                                                                    <div className="verticalMediumWide hover-box text-center ws-12">

                                                                        <ul className="hover-block  ptl mtl box overflowVisible">
                                                                            <li className="hover-box ws-12" style={{ margin: "12px 0 0 -6px" }}>
                                                                                <a className="icon-btn edit btn-sm ws-12 mb" onClick={() => SelectStatus(values, 1)}>Processed</a>
                                                                            </li>
                                                                            <li className="hover-box ws-12" style={{ margin: "12px 0 0 -6px" }}>
                                                                                <a className="icon-btn edit btn-sm ws-12" onClick={() => SelectStatus(values, 2)}>Closed</a>
                                                                            </li>
                                                                            <li className="hover-box ws-12" style={{ margin: "12px 0 0 -6px" }}>
                                                                                <a className="icon-btn warning btn-sm ws-12" onClick={() => SelectStatus(values, 3)}>Do not process</a>
                                                                            </li>
                                                                            <li className="hover-box ws-12" style={{ margin: "12px 0 0 -6px" }}>
                                                                                <a className="icon-btn info btn-sm ws-12" onClick={() => SelectStatus(values, 4)}>Re-Open</a>
                                                                            </li>
                                                                            <li className="hover-box ws-12" style={{ margin: "12px 0 0 -6px" }}>
                                                                                <a className="icon-btn info btn-sm ws-12" onClick={() => SelectStatus(values, 5)}>Unprocessed</a>
                                                                            </li>
                                                                        </ul>
                                                                        <button className="btn icon-btn edit forceSingleLine">Choose a status</button>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    )
                                                })}

                                            {
                                                (() => {
                                                    if (values?.contracts?.length > 10) {
                                                        return <Pagination onPageChange={SuggestedPaymentSubPagination} totalRow={values?.contracts?.length} />
                                                    }
                                                })()
                                            }

                                        </>
                                        }
                                    </div>

                                </div>
                            </div>
                        )
                    })}

                    {
                        (() => {
                            if (paymentDetailTemp.length > 10) {
                                return <Pagination onPageChange={SuggestedPaymentPagination} totalRow={paymentDetailTemp.length} />
                            }
                        })()
                    }
                </div>

            </div>

            {
                (() => {
                    if (suggestedPaymentUploadStatus) {
                        return <SuggestedPaymentUploadBox param={suggestedPaymentUploadStatus} SuggestedPaymentUploadClose={SuggestedPaymentUploadClose} />
                    }

                    if (advancedSearchStatus) {
                        return <AdvancedSearchBox param={advancedSearchStatus} AdvancedSearchClose={AdvancedSearchClose} />
                    }

                    if (deleteStatus && deleteType != "savePaymentKontactPaymentInfo") {
                        return <DeleteDialogueBox param={deleteStatus} onChange={DeleteDialogueBoxClose} message={deleteMessage} descriptionBelow={description} />
                    }

                    if (deleteStatus && deleteType == "savePaymentKontactPaymentInfo") {
                        return <DeleteDialogueBoxV2 param={deleteStatus} onChange={DeleteDialogueBoxCloseV2} message={deleteMessage} descriptionBelow={description} title="Note" />
                    }

                    if (exportOption) {
                        return <ExportOption exportOption={exportOption} onChange={onChangeExportOption} fileName={"SuggestedPayments"} />
                    }
                })()
            }
        </div >}
    </>
    )
}